import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { CardOverlay } from 'components/Card';
import { type ChildrenProps } from 'components';
export const PrePortalContainer = t0 => {
  const $ = _c(15);
  const {
    children,
    title,
    className,
    noOverlay
  } = t0;
  const [showImages, setShowImages] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const timer = setTimeout(() => setShowImages(true), 500);
      return () => clearTimeout(timer);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `absolute inset-x-0 h-[50vh] top-0 bg-[url("/swift-arc.png")] bg-no-repeat bg-center bg-contain transition-opacity duration-500 ${showImages ? "opacity-100" : "opacity-0"}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `absolute inset-x-0 bottom-0 h-[50vh] bg-[url("/swift-direction.png")] bg-no-repeat bg-center bg-contain transition-opacity duration-500 ${showImages ? "opacity-100" : "opacity-0"}`;
  let t6;
  if ($[4] !== t5) {
    t6 = <div className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== className || $[8] !== noOverlay || $[9] !== title) {
    t7 = noOverlay ? children : <CardOverlay title={title} className={twMerge("flex flex-col items-center ", className)}>{children}</CardOverlay>;
    $[6] = children;
    $[7] = className;
    $[8] = noOverlay;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t7) {
    t8 = <div className="flex h-screen items-center justify-center relative">{t4}{t6}{t7}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};